module.exports = __webpack_public_path__ + "static/media/12 - Phillipi & Rodrigo - Minas.a66fea26.mp3";